<template>
  <div class="flex flex-col items-start text-left leading-snug" :title="tooltip">
    <span
      v-if="label"
      class="px-2 py-0.5 bg-indigo-50 text-indigo-700 rounded-2xl text-xs font-medium"
    >
      {{ label }}
    </span>
    <span v-else class="text-slate-400 text-sm">—</span>

    <!-- Siguiente ciclo (calculado en el servidor: next_recurrence_date) -->
    <span v-if="nextDate" class="text-slate-600 text-xs mt-0.5">
      Next:
      <span
        class="font-semibold"
        :class="isPending ? 'text-amber-600' : 'text-neutral-900'"
        >{{ nextDate }}</span
      >
    </span>
    <span v-else-if="project?.recurrence_ended" class="text-slate-500 text-xs mt-0.5">
      Series ended
    </span>
    <span v-else-if="until" class="text-slate-500 text-xs mt-0.5">
      until {{ until }}
    </span>
  </div>
</template>

<script>
import { computed } from "vue";
import helpers from "@/helpers";

const formatDate = (value) => helpers.dueDateInfo(value, "Completed").date;

export default {
  props: {
    project: { type: Object, default: null },
  },
  setup(props) {
    const label = computed(() => helpers.projectRecurrenceLabel(props.project));
    const nextDate = computed(() =>
      props.project?.next_recurrence_date
        ? formatDate(props.project.next_recurrence_date)
        : ""
    );
    const until = computed(() =>
      props.project?.recurrence && props.project?.recurrence_end
        ? formatDate(props.project.recurrence_end)
        : ""
    );
    // La fecha ya pasó pero el siguiente ciclo no se ha creado: el job espera a
    // que venza el proyecto actual y todas sus tareas estén completas.
    const isPending = computed(
      () =>
        Boolean(props.project?.next_recurrence_date) &&
        helpers.dueDateInfo(props.project.next_recurrence_date).tone === "overdue"
    );
    // Tooltip con el detalle completo (las celdas de tabla solo muestran 2 líneas)
    const tooltip = computed(() => {
      const parts = [];
      if (nextDate.value) parts.push(`Next recurrence: ${nextDate.value}`);
      if (isPending.value) {
        parts.push(
          "Pending: the next cycle is created once the current project is past its due date and all its tasks are complete"
        );
      }
      if (props.project?.recurrence_ended) parts.push("No more recurrences");
      if (props.project?.recurrence_end) {
        parts.push(`Ends: ${formatDate(props.project.recurrence_end)}`);
      }
      return parts.join("\n") || null;
    });
    return { label, nextDate, until, tooltip, isPending };
  },
};
</script>
